export default {
  MODULE_NAME: 'app',
};
